module.exports = __webpack_public_path__ + "static/media/gallery.a85166eb.svg";